import { useEffect, useRef } from "react";
import { useNavigation } from "react-router-dom";
import { useToast } from "./ui/use-toast";

export const RouteLoader = () => {
  const navigation = useNavigation();
  const { toast, dismiss } = useToast();
  const toastIdRef = useRef<string | null>(null);

  useEffect(() => {
    if (navigation.state === "loading") {
      if (!toastIdRef.current) {
        toastIdRef.current = toast({
          title: "Loading page...",
          duration: Infinity,
        }).id;
      }
    } else {
      if (toastIdRef.current) {
        dismiss(toastIdRef.current);
        toastIdRef.current = null;
      }
    }
  }, [navigation.state]);

  return null;
};
